<nz-table
  #sortTable
  [nzData]="(organizationUsers$ | async)?.result?.items ?? []"
  [nzFrontPagination]="false"
  [nzLoading]="loading"
  [nzTotal]="(organizationUsers$ | async)?.result?.totalRows || 0"
  [(nzPageIndex)]="pageIndex"
  [nzPageSize]="pageSize"
  (nzQueryParams)="onQueryParamsChange($event)"
  [nzScroll]="{ x: '700px' }">
  <thead>
    <tr>
      <th nzWidth="50px">{{ listOfColumn[0].title }}</th>
      <th [nzSortFn]="true" [nzColumnKey]="listOfColumn[1].key">
        {{ listOfColumn[1].title }}
      </th>
      <th [nzSortFn]="true" [nzColumnKey]="listOfColumn[2].key">
        {{ listOfColumn[2].title }}
      </th>
      <th [nzSortFn]="true" [nzColumnKey]="listOfColumn[3].key">
        {{ listOfColumn[3].title }}
      </th>
      <th [nzSortFn]="true" [nzColumnKey]="listOfColumn[4].key">
        {{ listOfColumn[4].title }}
      </th>
      <th [nzSortFn]="true" [nzColumnKey]="listOfColumn[5].key">
        {{ listOfColumn[5].title }}
      </th>
      <th nzWidth="50px">
        {{ listOfColumn[6].title }}
      </th>
    </tr>
  </thead>

  <tbody>
    @for (data of sortTable.data; track data) {
      <tr>
        <td>
          <button
            (click)="viewOrganizationUser(data)"
            nz-button
            nzType="text"
            class="data-wrapper">
            <svg-icon
              src="/assets/icon/icon-table-next.svg"
              class="icon s-12"></svg-icon>
          </button>
        </td>
        <td class="with-icon">
          <button
            nz-button
            nzType="text"
            (click)="viewOrganizationUser(data)"
            title="{{ data.email }}">
            {{ data.email }}
          </button>
        </td>
        <td>{{ data.name }}</td>
        <td>{{ (data.lastLogin | userDate: 'MM/dd/yyyy') || '-' }}</td>
        <td>
          <div
            class="status"
            [class.active]="data.status === userStatus.ACTIVE"
            [class.pending]="data.status === userStatus.PENDING"
            [class.inactive]="data.status === userStatus.INACTIVE">
            <span>{{ data.status }}</span>
          </div>
        </td>
        <td>{{ data.title || '-' }}</td>
        <td nzWidth="50px" nzRight>
          <div class="action-dropdown">
            <button
              nz-dropdown
              [nzDropdownMenu]="menu"
              nzTrigger="click"
              [nzPlacement]="'bottomLeft'"
              nzType="text"
              type="button">
              <svg-icon
                [title]="'More options'"
                src="/assets/icon/icon-more.svg"
                class="icon s-20"></svg-icon>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li
                  nz-menu-item
                  nzClickHide="false"
                  class="action-list-item"
                  tabindex="0"
                  (click)="viewOrganizationUser(data)"
                  (keydown.enter)="viewOrganizationUser(data)"
                  (keydown.space)="viewOrganizationUser(data)">
                  <svg-icon
                    src="/assets/icon/icon-user-sm.svg"
                    class="icon s-16 fw-500"></svg-icon>
                  <span class="text s-14">User Details</span>
                </li>
                <li
                  nz-menu-item
                  nzClickHide="false"
                  class="action-list-item"
                  *ngIf="data.status !== 'DELETED'"
                  tabindex="0"
                  (click)="resendEmail(data.id)"
                  (keydown.enter)="resendEmail(data.id)"
                  (keydown.space)="resendEmail(data.id)">
                  <svg-icon
                    src="/assets/icon/icon-email.svg"
                    class="icon s-16 fw-500"></svg-icon>
                  <span class="text s-14">Resend Email</span>
                </li>
                <li
                  nz-menu-item
                  nzClickHide="false"
                  class="action-list-item"
                  *ngIf="data.status !== 'DELETED'"
                  tabindex="0"
                  (click)="showDeleteModal(data.id)"
                  (keydown.enter)="showDeleteModal(data.id)"
                  (keydown.space)="showDeleteModal(data.id)">
                  <svg-icon
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-16 fw-500"></svg-icon>
                  <span class="text s-14">Delete</span>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<nz-modal
  [(nzVisible)]="isOpenDeleteModel"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancelMiddle()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-red">
        <svg-icon
          src="/assets/icon/icon-trash-red.svg"
          class="icon s-20"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Delete User</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Are you sure you want to delete this User?
      </p>
      <!-- circle-pattern -->
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleCancelMiddle()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn btn-cancel"
        (click)="handleOkMiddle()">
        Delete
      </button>
    </div>
  </ng-template>
</nz-modal>
